import React from 'react';
import SvgIcon from '../../../SvgIcon';
import { getEntityTypeIcon, getGameTypeImgType } from '@/pages/home/pages/home/Explore/_config/common';
import GameImage from '@/pages/home/components/GameImage';
import { Bubble } from 'tea-component';
import { useIntl } from 'umi';
import { StatusBubbleContent } from '@intelligence/components/DataSourceComponents';
import type { ICardHomeItemProps } from '../types';

export default function CardHomeItem(props: ICardHomeItemProps) {
  const { data, searchRecordsHandle } = props;
  const { trendingData } = data;
  const { info } = trendingData || {};
  const {
    cover,
    entity_name: entityName,
    entity_type: entityType,
    game_id: gameId,
    game_name: gameName,
    release_time: releaseTime,
    match_score: matchScore,
    other_name: otherName,
    publisher,
    inactive,
  } = info || {};
  const { formatMessage } = useIntl(); // 中英切换方法

  const infoData = {
    game_id: gameId,
    game_name: gameName,
    entity_name: entityName,
    other_name: otherName,
    release_time: releaseTime,
    match_score: matchScore,
    entity_type: entityType,
    cover,
    publisher,
  };

  return <div className='card-box' onClick={() => { searchRecordsHandle(data.title, infoData) }}>
    <GameImage
      className={getGameTypeImgType(data.type)}
      src={data.img}
      alt={'flag'}
      entityType={data.type}
    />
    <div className='card-box-context'>
      {/* action-title 搜到匹配字体颜色和card-box-title一起使用 */}
      <div className='card-box-titleflex'>
        <div className='card-box-title'>{data.title}</div>
        {inactive && entityType === 'mobile' ? (
          <Bubble dark content={<StatusBubbleContent descId="dbi_inactive_hover" />}>
            <span className="dbi-inactive-tag">{formatMessage({ id: 'dbi_inactive' })}</span>
          </Bubble>
        ) : null}
      </div>
      <div className='card-box-flex'>
        <SvgIcon type={getEntityTypeIcon(data.type)} className='card-item-icon' />
        <div className='card-box-span'>
          <span className='card-box-text'>{formatMessage({ id: 'dbh_metric_release' }) + ' ' + (data.release ? data.release : formatMessage({ id: 'dbh_upcoming' }))}</span>
          <span className='card-box-text'>{data.publisher}</span>
          {/* {data.tabData.map((e: any, i: any) => {
            return <span key={i} className='card-box-text'>{formatMessage({ id: 'dbh_metric_release' }) + ' ' + e ? e  : formatMessage({ id: 'dbh_upcoming' })}</span>
          })} */}
        </div>
      </div>
    </div>
  </div>
};

